'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
const defaults = {
  category: '',
  companyName: '',
  firstPublishedAt: 0,
  certifiedAt: null,
  iconUrl: '',
  id: 0,
  installed: false,
  installsCount: 0,
  name: '',
  offeringId: 0,
  reviewSummary: null,
  sourceId: '',
  slug: '',
  tagline: ''
};

class ThinListing extends Immutable.Record(defaults) {
  constructor(values) {
    super(cleanObject(values));
  }

}

export default ThinListing;